import React from 'react';
import { useSelector } from 'react-redux';
import MoneyComponent from "../elements/MoneyComponent.jsx";
import Category from "../../models/Category.jsx";


export default function AmountRemainingToBudget({}) {
	const { categories, categoryGroups, selectedDates } = useSelector((state) => state.dashboard);
	const freeFormBudgetingFeatureActive = useSelector((state) => state.settings.freeFormBudgetingFeatureActive);

	return null;
	if(freeFormBudgetingFeatureActive) {
		return null;
	}

	const {
		totalRemainingToBudget,
	} = Category.getSummaryTotals(categories, categoryGroups, selectedDates);

	let overBudget = totalRemainingToBudget < -1;
	let lotsRemaining = totalRemainingToBudget > 1;
	let allGood = !overBudget && !lotsRemaining;

	return (
		<div>
			{allGood &&
			<span className='positive'>All is Budgeted!</span>
			}
			{lotsRemaining &&
			<span>
				Amount Remaining To Budget <MoneyComponent amount={totalRemainingToBudget} />
			</span>
			}
			{overBudget &&
			<span>
				Over Budget By
				<MoneyComponent
					showPlus={false}
					showMinusSignIfNegative={false}
					amount={totalRemainingToBudget}
				/>
			</span>
			}
		</div>
	);
}